import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../components/BrandLogo';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const features = [
    t('welcome.feature1', 'Outlines, beats & plot threads the AI keeps track of'),
    t('welcome.feature2', 'Characters with arcs it actually remembers'),
    t('welcome.feature3', 'Continue, suggest & rewrite — in your voice'),
    t('welcome.feature4', 'Novels, fan fiction, screenplays, poetry & more'),
  ];

  return (
    <div className="min-h-screen bg-light-bg flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 w-full max-w-md mx-auto text-center">
        <BrandLogo
          imgClassName="h-20 w-auto mx-auto mb-8"
          textClassName="block mb-8 text-4xl font-bold tracking-tight"
        />

        <h1
          className="font-cormorant text-4xl md:text-5xl font-bold leading-[1.1] mb-4"
          style={{ color: 'var(--ds-text-primary)' }}
        >
          {t('welcome.headline', 'The AI co-writer that never loses the plot')}
        </h1>
        <p className="text-lg mb-8" style={{ color: 'var(--ds-text-secondary)' }}>
          {t(
            'welcome.subtitle',
            'Outline, build characters, and draft chapters — for novels, fan fiction, and more.',
          )}
        </p>

        <ul className="space-y-3 mb-10 text-left w-full max-w-sm mx-auto">
          {features.map((f, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0" />
              <span style={{ color: 'var(--ds-text-primary)' }}>{f}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={() => navigate('/signup')}
          className="w-full max-w-sm py-4 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full shadow-sm transition-colors"
        >
          {t('welcome.startCta', 'Start writing — free')}
        </button>
        <button
          onClick={() => navigate('/login')}
          className="mt-4 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
        >
          {t('welcome.haveAccount', 'I already have an account')}
        </button>
      </div>
    </div>
  );
};

export default Welcome;
